/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
<template>
    <v-container>
		<!--inicio Dialog extra-->
<v-dialog v-model="dialogDatosPersonales"  max-width="1100" persistent>
        <v-card tile class="pago-dialog">
            <v-toolbar card dark color="#1f97b9">
                <v-toolbar-title>SOLO LOS ULTIMOS DATOS!!!</v-toolbar-title>
                <v-spacer></v-spacer>
                <!--<v-btn class="btn-close-pago-dialog" dark icon @click="dialogDatosPersonales = false">
                    <v-img :src='require("../../../assets/static/img/cerrar.png")' max-height="25" contain></v-img>
                </v-btn>-->
            </v-toolbar>
            <v-card-text>
            <v-form ref="datosPersonales">
				<v-layout row wrap justify-center align-center>
            		<v-flex md4 sm4 xs12 px-3>	
							<layout class="numeroContacto" row wrap>  
									<v-flex xs12 md2>      
										<v-select
											v-model="codigoDefault"
											:items="codigos"
											:rules="rules.nameRules"
											append-icon="fas fa-caret-down"
											label="Código País"
											@change="changePhoneLength">
											<img :src='require("../../../assets/static/img/telefono.png")'  alt="icono de numero telefonico" style="width: 25px;height:25px;" slot="prepend">
										</v-select>
								</v-flex> 
									<v-flex class="textNumeroContacto" md4 md8>
										<v-text-field
											v-model="dataPersonalF.telefono"
											label="Teléfono"
											color="#1f97b9"
											:counter="phoneLength"
											:maxlength="phoneLength"
											:rules="rules.phoneRules"
											required>
										</v-text-field>
									</v-flex>
							</layout>
							
						<div class="correoContacto">
							<v-text-field 
								slot="activator"
								v-model="dataPersonalF.email"
								label="Ingrese su Correo"
								color="#1f97b9"
								:rules="rules.emailRules"
								required> 
								<img :src='require("../../../assets/static/img/email.png")'  alt="icono del email" style="width: 25px;height:25px;" slot="prepend">
							</v-text-field>
						</div>	
						<!-- sin uso<v-tooltip right v-model="showTooltip" max-width="350px" :color="typeTooltip == 'warning' ? '#616161' : 'red'">
							</v-tooltip>-->
					</v-flex>
				</v-layout>		
            </v-form>	
			<v-divider class="my-3"></v-divider>
                <v-layout v-if="!loadingFinalValue && dataPersonalF.email !== '' && dataPersonalF.telefono !== ''" row wrap justify-center align-center>
                    <v-flex sm12 md4 xs12 justify-center align-center class="text-xs-center">
	                    <v-btn color="#1f97b9" outline large class="third-step-button mt-3" @click="goAfterPersonalData()" >
                              <v-layout row wrap pa-3 justify-center align-center>
                                    <span>Siguiente</span> 
				                </v-layout>
                           </v-btn>
                      </v-flex>
    	        </v-layout>	
            </v-card-text>
                <div style="flex: 1 1 auto;"></div>
        </v-card>
    </v-dialog>		
<!--Fin Dialog extra-->

		<v-layout row wrap v-if="loadingFinalValue" style="min-height:300px;" align-center justify-center pa-0>
			<v-flex md6 sm6 xs12>
    		<LoadingLogo/>
    	</v-flex>
			<v-flex md6 sm6 xs12>
				<h3 class="color-duo">Unos segundos por favor</h3>
				<h3 class="color-duo">estamos calculando un mejor precio</h3>
			</v-flex>
		</v-layout>


		<v-form ref="form" v-if="!continuar">
			<v-layout row wrap my-2>
				<v-flex md12 sm12 xs12>
					<v-toolbar color="#1f97b9" dark>
						<img :src='require("../../../assets/static/img/clipboard.png")'  alt="icono de informacion" style="width: 30px;">
						<v-toolbar-title>
							<p class="mb-0">SERVICIO Completo</p>
							<p class="mb-0 caption">INCLUYE TRANSPORTE Y SERVICIO DE CARGA Y DESCARGA</p>
						</v-toolbar-title>
					</v-toolbar>
				</v-flex>
			</v-layout>

			<v-layout v-if="$vuetify.breakpoint.mdAndUp" row wrap justify-center justify-space-around px-3 my-3>
				<!-- mapa y elementos -->
				<v-flex v-if="$vuetify.breakpoint.mdAndUp" md5 xs12 px-3>
						<div style="width: 100%">
							<h2 class="third-info-title responsiveHelpers" @click="dialogAddress = true">RUTA</h2>
								<GmapMap
									ref="mapDirections"
									class="third-info-map-container"
									v-if="!loadingFinalValue && allData.first.direccion_origen"
									:center="allData.first.direccion_origen.marker"
									:zoom="15"
									style="width: 100%"
									:options="{
										zoomControl: false,
										mapTypeControl: false,
										scaleControl: false,
										streetViewControl: false,
										rotateControl: false,
										fullscreenControl: false,
										disableDefaultUi: true
									}"
								@click="dialogAddress = true"
							>
								<gmap-polyline
									:options="{'strokeColor': '#1f97b9'}"
									:path="theLatLngs" 
									:editable="false" 
									ref="polygon">
								</gmap-polyline>
								<GmapMarker
									v-if="!loadingFinalValue"
									:position="allData.first.direccion_origen.marker" />
								/>
								<GmapMarker
									v-if="!loadingFinalValue"
									:position="allData.first.direccion_destino.marker" />
								/>
							</GmapMap>
						</div>
						<v-flex >
							<h2 class="third-info-title red--text body-2">ELEMENTOS</h2>
							<div class="third-info-container link" @click="dialogElementos = true">
								<v-icon class="contact-icon-in-button" left dense color="#2f97b8">fas fa-search</v-icon>
								<p class="font-weight-bold display-4 third-info-qty">{{elementsQty}}</p>
							</div>
						</v-flex>
				</v-flex>
				<!-- precio basico -->
				<v-col md4 xs6 px-3>
					<h2 class="third-info-title responsiveHelpers" style="color: white">SOLO TRANSPORTE</h2>
					<v-layout xs6 column :class="{ 'mobile-container text-xs-center': $vuetify.breakpoint.smAndDown, 'fifth-info-container text-xs-center': $vuetify.breakpoint.mdAndUp}">
						<v-flex>
							<div>
								<img :src='require("../../../assets/static/img/Cajas-apiladas.png")'  alt="imagen de las cajas apiladas">
							</div>
						</v-flex>
						<v-flex column>
							<div>
								<div v-if="!allData.ajuste_mudanza" class="font-weight-bold display-2 third-info-qty">
									<p  v-if="allData.finalValue" style="font-size: 20px!important">{{this.setOfertaValue(allData.baseValue.amount, 1) | CLP}}</p>
									<p style="color: red; font-size: 15px; line-height: 0.7">Solo Transporte, <br> cliente carga y descarga</p>
									<v-btn v-if="$vuetify.breakpoint.smAndDown" :disabled="!terminos" @click="reservaPedido(1, 'CuadradosBasico')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA <br>{{ this.setOfertaValue(allData.baseValue.amount, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-btn v-else :disabled="!terminos" @click="reservaPedido(1, 'CuadradosBasico')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA {{ this.setOfertaValue(allData.baseValue.amount, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-toolbar-title>							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
										<p v-if="$vuetify.breakpoint.mdAndUp" style="margin-bottom:0; font-size: smaller;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
									<p v-if="$vuetify.breakpoint.smAndDown" style="text-align: justify!important; font-size: x-small;" slot="append" ><router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link></p>
								</div>
								<div v-else class="font-weight-bold display-2 third-info-qty">
									<p  v-if="allData.ajuste_mudanza" style="font-size: 20px!important">{{this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorBasico, 1) | CLP}}</p><!--here-->
									<p style="color: red; font-size: 15px; line-height: 0.7">Solo Transporte, <br> cliente carga y descarga</p>
									<v-btn v-if="$vuetify.breakpoint.smAndDown" :disabled="!terminos" @click="reservaPedido(1, 'CuadradosBasico')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 19px!important">RESERVA <br>{{ this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorBasico, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-btn v-else :disabled="!terminos" @click="reservaPedido(1, 'CuadradosBasico')" color="#1f97b9" outline large :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA {{ this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorBasico, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
										
									<v-toolbar-title>							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
										<p v-if="$vuetify.breakpoint.mdAndUp" style="margin-bottom:0; font-size: smaller;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
									<p v-if="$vuetify.breakpoint.smAndDown" style="text-align: justify!important; font-size: xx-small;" slot="append" ><router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link></p>
								</div>
							</div>
						</v-flex>
					</v-layout>
				</v-col>
				<!-- precio completo -->
				<v-col md4 xs6 px-3>
					<h2 class="third-info-title responsiveHelpers" style="color: white">CON AYUDANTES</h2>
					<v-layout xs6 column :class="{ 'mobile-container text-xs-center': $vuetify.breakpoint.smAndDown, 'fifth-info-container text-xs-center': $vuetify.breakpoint.mdAndUp}">
						<v-flex>
							<div>
								<img style="max-height: 180px !important;" :src='require("../../../assets/static/img/ayudantes.png")'  alt="imagen de los ayudantes">
							</div>
						</v-flex>
						<v-flex column>
							<div v-if="errorPrice">
								<div class="third-info-qty pa-2">
									<p style="margin: 0" class="caption">Lo sentimos hubo un error al cargar el precio final, por favor intenta calcular nuevamente presionando el siguiente botón.</p>
									<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-1 caption" @click="finalCalc()">
										Calcular valor
									</v-btn>
								</div>
							</div>
							<div ref="" v-else @click="reservaPedido(2, 'CuadradosCompleto')">
								<div v-if="allData.first.oferta.activo && allData.baseValue && allData.first.oferta.completo && !allData.ajuste_mudanza" class="font-weight-bold subheading third-info-qty ">
									<p class="caption responsiveOferta">¡Hay una oferta para esta cotización!</p>
									<p  v-if="allData.ajuste_mudanza" style="font-size: 20px!important">{{this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorCompleto, 1) | CLP}}</p>
									<p style="font-size: 15px; line-height: 0.7">Incluye servicio de <br> carga y descarga</p>
									<v-btn v-if="$vuetify.breakpoint.smAndDown" :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA <br>{{ this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorCompleto, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-btn v-else :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline large :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA {{ this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorCompleto, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-toolbar-title>							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
										<p v-if="$vuetify.breakpoint.mdAndUp" style="margin-bottom:0; font-size: smaller;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
									<p v-if="$vuetify.breakpoint.smAndDown" style="text-align: justify!important; font-size: x-small;" slot="append" ><router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link></p>
								</div>
								<div v-else-if="!allData.ajuste_mudanza" class="font-weight-bold display-2 third-info-qty">
									<p  v-if="allData.finalValue" style="font-size: 20px!important">{{allData.finalValue.amount | CLP}}</p>
									<p style="font-size: 15px; line-height: 0.7">Incluye servicio de <br> carga y descarga.</p>
									<p style="font-size: 15px; line-height: 0.7">Por ascensor o de <br> primer a primer piso.</p> 
									    
									<v-btn v-if="$vuetify.breakpoint.smAndDown" :disabled="!terminos" @click="reservaPedido(2, 'Cuadrados')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA <br>{{ this.setOfertaValue(allData.finalValue.amount, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-btn v-else :disabled="!terminos" @click="reservaPedido(2, 'Cuadrados')" color="#1f97b9" outline large :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA {{ this.setOfertaValue(allData.finalValue.amount, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-toolbar-title>							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
										<p v-if="$vuetify.breakpoint.mdAndUp" style="margin-bottom:0; font-size: smaller;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
									<p v-if="$vuetify.breakpoint.smAndDown" style="text-align: justify!important; font-size: xx-small;" slot="append" ><router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link></p>
								</div>
								<div v-else-if="allData.ajuste_mudanza && allData.first.oferta.activo && allData.ajuste_mudanza.ajuste_valorCompleto && !allData.first.oferta.completo" class="font-weight-bold subheading third-info-qty">
									<p class="caption">¡Hay una oferta para esta cotización!</p>
									<p style="margin: 0">Normal: {{allData.ajuste_mudanza.ajuste_valorCompleto | CLP}}</p>
									<p style="margin: 0">Descuento: {{allData.first.oferta.monto | CLP}}</p>
									<p style="margin-bottom: 0; margin-top: 5px; font-size: 20px!important" class="title">Oferta: {{allData.ajuste_mudanza.ajuste_valorCompleto - allData.first.oferta.monto | CLP}}</p>
									<p style="font-size: 15px; line-height: 0.7">Incluye servicio de <br> carga y descarga</p>
									<v-btn v-if="$vuetify.breakpoint.smAndDown" :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA <br>{{ (allData.ajuste_mudanza.ajuste_valorCompleto - allData.first.oferta.monto) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-btn v-else :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline large :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA {{ (allData.ajuste_mudanza.ajuste_valorCompleto - allData.first.oferta.monto) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-toolbar-title>							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
										<p v-if="$vuetify.breakpoint.mdAndUp" style="margin-bottom:0; font-size: smaller;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
									<p v-if="$vuetify.breakpoint.smAndDown" style="text-align: justify!important; font-size: x-small;" slot="append" ><router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link></p>
								</div>
								<div v-else class="font-weight-bold display-2 third-info-qty">
									<p  v-if="allData.ajuste_mudanza" style="font-size: 20px!important">{{allData.ajuste_mudanza.ajuste_valorCompleto | CLP}}</p><!--here-->
									<p style="font-size: 15px; line-height: 0.7">Incluye servicio de <br> carga y descarga</p>
									<v-btn v-if="$vuetify.breakpoint.smAndDown" :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline :class="{ 'mobile-button': $vuetify.breakpoint.smAndDown, 'third-step-button mt-3': $vuetify.breakpoint.mdAndUp}" style="font-size: 21px!important">RESERVA <br>{{ (allData.ajuste_mudanza.ajuste_valorCompleto) * 0.3 | CLP }}&nbsp;
										</v-btn>
									<v-btn v-if="$vuetify.breakpoint.mdAndUp" :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline large class="third-step-button mt-3'" style="font-size: 21px!important">RESERVA {{ (allData.ajuste_mudanza.ajuste_valorCompleto) * 0.3 | CLP }}&nbsp;</v-btn>
									<v-toolbar-title class="text-xs-center">							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
										<p v-if="$vuetify.breakpoint.mdAndUp" style="margin-bottom:0; font-size: smaller;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
									<p v-if="$vuetify.breakpoint.smAndDown" style="text-align: justify!important; font-size: x-small;" slot="append" ><router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link></p>
								</div>
							</div>
						</v-flex>
					</v-layout>
				</v-col>

				<v-flex v-if="$vuetify.breakpoint.smAndDown" md5 xs12 px-3>
						<div style="width: 100%">
							<h2 class="third-info-title responsiveHelpers" @click="dialogAddress = true">RUTA</h2>
								<GmapMap
									ref="mapDirections"
									class="third-info-map-container"
									v-if="!loadingFinalValue && allData.first.direccion_origen"
									:center="allData.first.direccion_origen.marker"
									:zoom="15"
									style="width: 100%"
									:options="{
										zoomControl: false,
										mapTypeControl: false,
										scaleControl: false,
										streetViewControl: false,
										rotateControl: false,
										fullscreenControl: false,
										disableDefaultUi: true
									}"
								@click="dialogAddress = true"
							>
								<gmap-polyline
									:options="{'strokeColor': '#1f97b9'}"
									:path="theLatLngs" 
									:editable="false" 
									ref="polygon">
								</gmap-polyline>
								<GmapMarker
									v-if="!loadingFinalValue"
									:position="allData.first.direccion_origen.marker" />
								/>
								<GmapMarker
									v-if="!loadingFinalValue"
									:position="allData.first.direccion_destino.marker" />
								/>
							</GmapMap>
						</div>
						<v-flex >
							<h2 class="third-info-title red--text body-2">ELEMENTOS</h2>
							<div class="third-info-container link" @click="dialogElementos = true">
								<v-icon class="contact-icon-in-button" left dense color="#2f97b8">fas fa-search</v-icon>
								<p class="font-weight-bold display-4 third-info-qty">{{elementsQty}}</p>
							</div>
						</v-flex>
				</v-flex>
			</v-layout>
			<!-- Desde aqui es mobile -->
			<v-layout v-else row wrap justify-center justify-space-around px-1 >
				<v-flex column xs5 class="mobile-container text-xs-center">
					<v-col>
						<div>
							<h2>Básico</h2>
						</div>
						<div>
							<img :src='require("../../../assets/static/img/Cajas-apiladas.png")'  alt="imagen de las cajas apiladas">
						</div>
						<div>
							<p  v-if="allData.ajuste_mudanza" style="font-size: 20px!important">{{this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorBasico, 1) | CLP}}</p>
							<p  v-else style="font-size: 20px!important">{{this.setOfertaValue(allData.baseValue.amount, 1) | CLP}}</p>
						</div>
						<div>
							<v-btn v-if="allData.ajuste_mudanza" :disabled="!terminos" @click="reservaPedido(1, 'CuadradosBasico')" color="#1f97b9" outline class="mobile-button" style="font-size: medium!important">RESERVA <br>{{ setOfertaValue(allData.baseValue.amount, 1) * 0.3 | CLP }}&nbsp;</v-btn>

							<v-btn v-else :disabled="!terminos" @click="reservaPedido(1, 'CuadradosBasico')" color="#1f97b9" outline class="mobile-button" style="font-size: medium!important">RESERVA <br>{{ setOfertaValue(allData.baseValue.amount, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
						</div>
						<div>
							<v-checkbox
								on-icon="far fa-check-square"
								off-icon="far fa-square"
								label=""
								hint="Leer términos y condiciones"
								v-model="terminos"
								class="terminos-check"
								hide-details
								persistent-hint
							>
							<p style="margin-bottom:0; font-size: x-small;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
								</p>
							</v-checkbox>
						</div>
					</v-col>
					
				</v-flex>
				<v-flex column xs5 class="mobile-container text-xs-center">
					<v-col>
						<div>
							<h2>Completo</h2>
						</div>
						<div>
							<img style="max-height: 180px !important;" :src='require("../../../assets/static/img/ayudantes.png")'  alt="imagen de los ayudantes">
						</div>
						<div>
							<p v-if="allData.ajuste_mudanza" style="font-size: 20px!important">{{allData.ajuste_mudanza.ajuste_valorCompleto | CLP}}</p>
							<p v-else style="font-size: 20px!important">{{allData.finalValue.amount | CLP}}</p>
						</div>
						<div>
							<v-btn v-if="allData.ajuste_mudanza" :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" color="#1f97b9" outline class="mobile-button" style="font-size: medium!important">RESERVA <br>{{ (allData.ajuste_mudanza.ajuste_valorCompleto) * 0.3 | CLP }}&nbsp;</v-btn>

							<v-btn v-else :disabled="!terminos" @click="reservaPedido(2, 'CuadradosCompleto')" mini color="#1f97b9" outline class="mobile-button" style="font-size: medium!important">RESERVA <br>{{ this.setOfertaValue(allData.finalValue.amount, 1) * 0.3 | CLP }}&nbsp;
										</v-btn>
						</div>
						<div px-2>
							<v-checkbox
								on-icon="far fa-check-square"
								off-icon="far fa-square"
								label=""
								hint="Leer términos y condiciones"
								v-model="terminos"
								class="terminos-check"
								hide-details
								persistent-hint
							>
							<p style="margin-bottom:0; font-size: x-small;" slot="append" >Acepto <router-link :to="{ name: 'terminos'}" target="_blank">Términos y Condiciones</router-link>
								</p>
							</v-checkbox>
						</div>
					</v-col>
					
				</v-flex>
				
				
			</v-layout>

			<v-layout row wrap mb-0 justify-center class="title-incluye-final">
				<v-flex md6 sm6 xs6 justify-center>
				</v-flex>
				<v-flex md3 sm3 xs3>
					<div :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}" class="mt-2">
						<h3 class="text-xs-center color-duo title">Solo transporte. Cliente carga y descarga</h3>
					</div>
				</v-flex>
				<v-flex md3 sm3 xs3>
					<div :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}" class="mt-2">
						<h3 class="text-xs-center color-duo title">Incluye servicio de carga y descarga</h3>
						<h3 class="text-xs-center color-duo title">Por ascensor si es edificio o de primer a primer piso.</h3>
					</div>
				</v-flex>
			</v-layout>

			<v-layout row wrap mt-2>
				<v-flex md12 sm12 xs12>
					<v-toolbar color="#1f97b9" dark class="toolbar-servicio-completo-reservar">
							<v-layout row wrap align-center style="width:100%" class="servicio-completo-title">
								<v-flex md6 sm6 xs6>
									<v-layout row wrap align-center :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pl-4': $vuetify.breakpoint.mdAndUp}">
										<img :src='require("../../../assets/static/img/clipboard.png")' style="width: 30px;"  alt="icono de notas">
										<v-toolbar-title class="subheading font-weight-medium title-fifth-select-service">SELECCIONE EL SERVICIO QUE MÁS LE ACOMODE</v-toolbar-title>
									</v-layout>
								</v-flex>
								<v-flex v-if="!allData.ajuste_mudanza" md3 sm3 xs3 align-center>
									<v-layout row wrap align-center justify-center>
										<span class="font-weight-bold headline third-info-qty" v-if="allData.baseValue">{{this.setOfertaValue(allData.baseValue.amount, 1) | CLP}}</span>
										<span class="font-weight-bold headline third-info-qty" v-else>-</span>
									</v-layout>
								</v-flex>
								<v-flex v-else-if="allData.ajuste_mudanza" md3 sm3 xs3 align-center>
									<v-layout row wrap align-center justify-center>
										<span class="font-weight-bold headline third-info-qty" v-if="allData.ajuste_mudanza.ajuste_valorBasico">{{this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorBasico, 1) | CLP}}</span>
										<span class="font-weight-bold headline third-info-qty" v-else>-</span>
									</v-layout>
								</v-flex>
								<v-flex v-if="!allData.ajuste_mudanza" md3 sm3 xs3 align-center>
									<v-layout row wrap align-center justify-center>
										<span class="font-weight-bold headline third-info-qty" v-if="allData.finalValue">{{this.setOfertaValue(allData.finalValue.amount, 2) | CLP}}</span>
										<span class="font-weight-bold headline third-info-qty" v-else>-</span>
									</v-layout>
								</v-flex>
								<v-flex v-if="allData.ajuste_mudanza" md3 sm3 xs3 align-center>
									<v-layout row wrap align-center justify-center>
										<span class="font-weight-bold headline third-info-qty" v-if="allData.ajuste_mudanza.ajuste_valorCompleto">{{this.setOfertaValue(allData.ajuste_mudanza.ajuste_valorCompleto, 2) | CLP}}</span>
										<span class="font-weight-bold headline third-info-qty" v-else>-</span>
									</v-layout>
								</v-flex>
							</v-layout>
					</v-toolbar>
				</v-flex>
			</v-layout>
			<v-layout row wrap mb-0 justify-center align-center
				v-for="(el, i) in mantenedores.incluye_final"
				:key="i"
				:class="{'row-tint-table': (i+1)%2 == 0}"
				>
				<v-flex md6 sm6 xs6 align-center justify-center class="servicio-completo first-incluye">
					<div :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
						<v-layout row class="ml-2 my-2" align-center justify-start>
								<img :src="el.icon" class="icon-incluye"/> <span class="text-incluye">{{el.text}}</span>
						</v-layout>
					</div>
				</v-flex>
				<v-flex md3 sm3 xs3 align-center justify-center>
					<div :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
						<v-layout row class="ml-2 my-0" align-center justify-center>
								<v-icon v-if="el.basico" color="#1f97b9" medium>fas fa-check</v-icon>
								<v-icon v-else color="red" medium>fas fa-times</v-icon>
						</v-layout>
					</div>
				</v-flex>
				<v-flex md3 sm3 xs3 align-center justify-center>
					<div :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}">
						<v-layout row class="ml-2 my-0" align-center justify-center>
								<v-icon v-if="el.completo" color="#1f97b9" medium>fas fa-check</v-icon>
								<v-icon v-else color="red" medium>fas fa-times</v-icon>
						</v-layout>
					</div>
				</v-flex>
			</v-layout>

			<v-layout row wrap my-2>
				<v-flex md12 sm12 xs12>
					<v-toolbar color="#1f97b9" dark class="toolbar-reservar">
							<v-layout row wrap align-center>
								<v-flex md6 sm6 xs12>				
									<v-toolbar-title>							
										<v-checkbox
											on-icon="far fa-check-square"
											off-icon="far fa-square"
											label=""
											color="white"
											hint="Leer términos y condiciones"
											v-model="terminos"
											class="terminos-check"
											hide-details
											persistent-hint
										>
											<p style="margin-bottom:0" slot="append" >Acepto los 
												<router-link style="color:white" :to="{ name: 'terminos'}" target="_blank">
												  Términos y Condiciones
												</router-link>
											</p>
										</v-checkbox>
									</v-toolbar-title>
								</v-flex>
								<v-flex md3 sm12 xs12 align-center justify-center>
									<v-layout row wrap align-center justify-center>
										<v-btn
											@click="reservaPedido(1, 'InferiorBasico')"
											dark
											flat
											:disabled="!terminos"
											class="px-5 subheading"
										>
											RESERVAR&nbsp;<span v-show="$vuetify.breakpoint.smAndDown">BÁSICO</span>
										</v-btn>
									</v-layout>
								</v-flex>
								<v-flex md3 sm12 xs12 align-center justify-center>
									<v-layout row wrap align-center justify-center>	
										<v-divider vertical v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
										<v-btn
											@click="reservaPedido(2, 'InferiorCompleto')"
											dark
											flat
											:disabled="!terminos"
											class="px-5 subheading"
										>
											RESERVAR&nbsp;<span v-show="$vuetify.breakpoint.smAndDown">COMPLETO</span>
										</v-btn>	
									</v-layout>
								</v-flex>
							</v-layout>
					</v-toolbar>
				</v-flex>
			</v-layout>

			<v-dialog
			  v-model="dialogAddress"
			  max-width="600"
			  v-if="allData.first"
			>
			  <v-card>
          <v-toolbar card dark color="#1f97b9">
            <v-toolbar-title>Direcciones Ingresadas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="btn-close-pago-dialog" dark icon @click="dialogAddress = false">
              <v-img :src='require("../../../assets/static/img/cerrar.png")' alt="icono de cerrar ventana" max-height="25" contain></v-img>
            </v-btn>
          </v-toolbar>

			    <v-card-text>
						<v-layout row wrap align-center>
							<v-flex md5 sm6 xs12>
								<v-layout row wrap pa-3 align-center>
									<img :src='require("../../../assets/static/img/direccion-o-d-duo.png")' alt="icono de direcciones" style="width: 25px;margin-right:16px;">
									<h3 class="text-duo">Dirección Origen:</h3>
								</v-layout>
							</v-flex>
							<v-flex md7 sm6 xs12>
								<p class="address-modal-address">{{allData.first.direccion_origen.direccion}}</p>
							</v-flex>
						</v-layout>
						<v-divider class="my-3"></v-divider>
						<v-layout row wrap align-center>
							<v-flex md5 sm6 xs12>
								<v-layout row wrap pa-3 align-center>
									<img :src='require("../../../assets/static/img/direccion-o-d-duo.png")'  alt="icono de direcciones" style="width: 25px;margin-right:16px;">
									<h3 class="text-duo">Dirección Destino:</h3>
								</v-layout>
							</v-flex>
							<v-flex md7 sm6 xs12>
								<p class="address-modal-address">{{allData.first.direccion_destino.direccion}}</p>
							</v-flex>
						</v-layout>
			    </v-card-text>

			    <v-card-actions>
          	<v-layout row wrap justify-center align-center>
          		<v-flex sm12 md12 xs12 justify-center align-center class="text-xs-center">
								<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-3" @click="goBack(4)">
									Deseo Modificarlas
								</v-btn>
							</v-flex>
						</v-layout>
			    </v-card-actions>
			  </v-card>
			</v-dialog>

			<v-dialog
			  v-model="dialogElementos"
			  max-width="600"
		    v-if="sortedElements.length > 0"
			>
			  <v-card>
          <v-toolbar card dark color="#1f97b9">
            <v-toolbar-title>Artículos Ingresados</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="btn-close-pago-dialog" dark icon @click="dialogElementos = false">
              <v-img :src='require("../../../assets/static/img/cerrar.png")' alt="icono de cerrar ventana" max-height="25" contain></v-img>
            </v-btn>
          </v-toolbar>
			    <v-card-text>

						<v-list two-line class="listado-elementos">
		          <template v-for="(item, index) in sortedElements">
		            <v-list-tile
		              :key="'sf-' + index"
		              class="tile-autoheight"
		            >
		              <v-list-tile-content>
		                <v-list-tile-sub-title>{{ item.cat }}</v-list-tile-sub-title>
		                <v-layout justify-space-between align-center v-for="(el, index1) in sortedElements[index].elements" style="width:100%" my-1 :key="index1">
      								<v-layout row wrap justify-start align-center>
												<v-img
													:src='el.img'
													max-height="40"
													max-width="40"
													class="mr-2"
													contain
												></v-img>
												{{ el.nombre }}
											</v-layout>
											<span>{{el.qty}}</span>
		                </v-layout>
		              </v-list-tile-content>

		            </v-list-tile>
		            <v-divider
		              v-if="index + 1 < allData.second.length"
		              :key="'div-' + index"
		            ></v-divider>
		          </template>
		        </v-list>

			    </v-card-text>

			    <v-card-actions>
          	<v-layout row wrap justify-center align-center>
          		<v-flex sm12 md12 xs12 justify-center align-center class="text-xs-center">
								<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-3" @click="goBack(3)">
									Deseo Modificarlos
								</v-btn>
							</v-flex>
						</v-layout>
			    </v-card-actions>
			  </v-card>
			</v-dialog>

		</v-form>

		<v-snackbar
      v-model="messageContact.show"
      :color="messageContact.type"
      right
      :timeout="4000"
      top
    >
      {{ messageContact.text }}
      <v-btn
        color="white"
        flat
        @click="messageContact.show = false"
      >
        Ok
      </v-btn>
    </v-snackbar>

	</v-container>
</template>
<style>
@media screen and (max-width: 650px) {
	.responsiveOferta {
		display: none;
	}
	.responsiveValues {
		font-size: 15px;
	}
	.responsiveHelpers {
		font-size: 18px;
		margin: 15px
	}
}
</style>
<script>
import { EventBus } from '../../../events.js'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import LoadingLogo from '../../../helpers/LoadingLogo'
export default {
    components: {LoadingLogo},
    data() {
        return {//aqui
			dialogDatosPersonales: false,
            sortedElements: [],
            allData: {
				first: {
					distancia: {},
					direccion_origen: {},
					direccion_destino: {}
				}
			},
            mantenedores: {},
            firstData: {
				distancia: {}
			},
            secondData: {},
            textTiempoVal: '',
            loadingFinalValue: true,
			continuar: true,
            messageContact: {
                show: false,
                type: '',
                text: ''
            },
            theLatLngs: [],
            errorPrice: false,
            terminos: false,
            dialogAddress: false,
            dialogElementos: false,
            datos: {
                origen: {},
                destino: {}
            },
            ns: '',
            pedidoID: '',
			phoneLength: 9,
            codigoDefault: '+56',
            codigos: ['+56', '+51','+54','+55', '+56','+57','+58','+1','+591','+593','+595','+598'],
			rules: {
                nameRules: [
                    v => !!v || 'Campo obligatorio'
                ],
                emailRules: [
						v => !!v || 'Campo obligatorio',
						v => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							if(re.test(v)){
								return true
							}
							return 'Verifica que el email sea válido'
						}
					]
            },
			dataPersonalF: {//aqui guardamos toda la data capturada, en este caso, telefono y mail
				nombre: '',
                telefono: '',
                email: '',
            },
			dialogPersonalesValidate: true,
			alreadyCalculated: false,
			direcciones: {
				destino: '',
				origen: ''
			},
        }
    },
    methods: {
		changePhoneLength() {
				if (this.codigoDefault === '+56' || this.codigoDefault === '+51' || this.codigoDefault === '+595') {
					this.phoneLength = 9
				} else if (this.codigoDefault === '+57' || this.codigoDefault === '+1') {
					this.phoneLength = 10
				} else if (this.codigoDefault === '+54') {
					this.phoneLength = 11
				} else {
					this.phoneLength = 12
				}
			},
		goAfterPersonalData() {//aqui
			if(this.dataPersonalF.telefono.length !== '' && this.dataPersonalF.email !==''){
				this.dataPersonalF.nombre = this.allData.first.personales.nombre
				if (this.dialogPersonalesValidate) {
					if (this.dataPersonalF.telefono.length === this.phoneLength) {
						this.dataPersonalF.telefono = this.codigoDefault + '' + this.dataPersonalF.telefono
					}
				}
				const data = {
					usuario: {
						nombre: this.dataPersonalF.nombre,
						email: this.dataPersonalF.email,
						telefono: this.dataPersonalF.telefono,
					}
				}
				const db = firebase.firestore()
				db.collection('pedidos').doc(this.pedidoID).update(data)
				this.dialogDatosPersonales = false
				this.continuar = false
				EventBus.$emit('datosDialogPersonales', data);//nuevo emmit
				this.allData.first.personales.email = this.dataPersonalF.email
				this.allData.first.personales.telefono = this.dataPersonalF.telefono
				this.getNsToSendEmail()
			}else{
				return 'ingrese los datos por favor'
			}
			
            
        },
        goBack(to){
            this.dialogAddress = false
            this.dialogElementos = false
			this.alreadyCalculated = false
            EventBus.$emit('goBackMudanza', to)
        },
        savePedido(){
            const here = this
            let finalData = {
                first: this.firstData,
                second: this.secondData,
                third: this.datos,
                basicoValue: this.allData.baseValue,
                completoValue: 0,
                finalValue: this.allData.baseValue,
                pedidoID: '',
                servicio: 'Básico'
            }
            EventBus.$emit('finalValue', finalData)
            /* setTimeout(function() {
                here.finalCalc()
            }, 800); */
        },
        initCalc(dialog = true) {
				try {this.loadingFinalValue = true
				// this.dialogDatosPersonales = true
				this.dialogPersonalesValidate ? this.dialogDatosPersonales = true : this.dialogDatosPersonales = false
				console.log('allData.first.distancia')
				console.log(this.allData.first.distancia)
				this.allData.tiempos = {
					distancia: Math.round(this.allData.first.distancia.duration.value/60),
					carga: this.tiempoCarga(this.allData.second)
				} 
				this.allData.fecha_servicio_obj = new Date(this.allData.first.date + 'T' + this.allData.first.time)
				this.allData.needDistanceCalc = true
				const baseValue = firebase.functions().httpsCallable('initialCalc')
				baseValue({data: this.allData})
				.then(({data}) =>{
					this.allData.baseValue = data
					this.setAjusteMudanza(1)
					// this.getRoute()
					this.countItems()
					this.savePedido()
					// EventBus.$emit('mudanzaThird');
				})
				.catch(httpsError => {
					this.loadingFinalValue = false
					// this.getRoute()
					this.countItems()
				})
			} catch (error) {
				console.log(error)
			}
            
        },
        finalCalc(retries = 0){
            let finalData = this.allData
            finalData.idPedido = this.pedidoID
            // this.loadingFinalValue = true
            this.errorPrice = false
            finalData.needDistanceCalc = true
            const baseValue = firebase.functions().httpsCallable('addAddressValue')
            baseValue({data: finalData})
            .then(({data}) =>{
                this.allData.finalValue = data
                if(this.allData.finalValue.amount < this.allData.baseValue.amount){this.allData.finalValue.amount = this.allData.baseValue.amount}
                this.loadingFinalValue = false
                this.setAjusteMudanza(2)
                // this.getRoute()
                this.countItems()
				if (!this.alreadyCalculated) {
					this.validate()
				}
                // this.getNsToSendEmail()
            })
            .catch(httpsError => {
                console.log('Error en addAddressValue')
                console.log(httpsError)
                if(retries < 3){
                    const retry = retries + 1
                    this.finalCalc(retry)
                }
                else{
                    this.loadingFinalValue = false
                    this.errorPrice = true
                    // this.getRoute()
                    this.countItems()
                    this.validate()
                }
            })
        },
        async getNsToSendEmail(){
            if (this.ns === '') {
                const self = this
                var ns= ''
                const db = firebase.firestore()
                await db.collection('pedidos').doc(this.pedidoID).get().then(function(doc){
                    ns = doc.data().NS.c_day + '.' + doc.data().NS.c_general + '.' + doc.data().NS.date
                })
                // self.ns = ns
                this.ns = ns
                this.sendToEmail()
            } else {
                this.sendToEmail()
            }
        },
		toThousandFilter(num) {
			return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, '.'))
		},
		sendToEmail(){
				let elementos = '<tr style="font-size: 12px;background-color: #1f97b9; color: white;"><th colspan="2" style="padding: 2px 5px;border: 1px solid #1f97b9;">ELEMENTOS A TRASLADAR</th><th style="padding: 2px 5px;border: 1px solid #1f97b9;">Por Escalera Origen</th><th style="padding: 2px 5px;border: 1px solid #1f97b9;">Por Escalera Destino</th></tr>'
				let total_elementos = 0
				let total_m3 = 0
				let escaleraOrigen = ''
				let escaleraDestino = ''
				this.allData.second.forEach(function(elemento, index) {
					elemento.escaleraO ? escaleraOrigen = '*' : escaleraOrigen = ''
					elemento.escaleraD ? escaleraDestino = '*' : escaleraDestino = ''
					total_elementos += elemento.qty
					total_m3 += elemento.qty * elemento.metros
					elementos += '<tr>'
					elementos += '<td colspan="2" style="border: 1px solid grey;padding: 2px 5px;">' + elemento.qty + ' ' + elemento.nombre + '</td>'
					elementos += '<td style="border: 1px solid grey;padding: 2px 5px;text-align:center;">' + escaleraOrigen + '</td>'
					elementos += '<td style="border: 1px solid grey;padding: 2px 5px;text-align:center;">' + escaleraDestino + '</td>'
					elementos += '</tr>'
				})
				elementos += '<tr><td></td><td></td></tr>'
				elementos += '<tr><td>' + total_elementos + ' Elementos</td>' + '<td>' + Math.round(total_m3 * 100) / 100 + ' m3</td></tr>'		
				const sendEmailRetomarPedido = firebase.functions().httpsCallable('sendEmailRetomarPedido')
				const data = {
					cliente:this.allData.first.personales.nombre,
					email: this.allData.first.personales.email,
					telefono: this.allData.first.personales.telefono,
					idPedido: this.pedidoID,
					origen: {
						direccion: this.allData.first.direccion_origen.direccion,
						piso: this.allData.third.origen.piso,
						departamento: 'No especificado'
					},
					destino: {
						direccion: this.allData.first.direccion_destino.direccion,
						piso: this.allData.third.destino.piso,
						departamento: 'No especificado'
					},
					elementos: elementos,
					ns: this.ns,
					valorBasico: this.toThousandFilter(this.allData.baseValue.amount),
					valorCompleto: this.toThousandFilter(this.allData.finalValue.amount),
					tipo: 'Con Ayudantes'
				}
				if (this.allData.ajuste_mudanza) {
					data.valorBasico = this.allData.ajuste_mudanza.ajuste_valorBasico
					data.valorCompleto = this.allData.ajuste_mudanza.ajuste_valorCompleto
				}
				const self = this
				sendEmailRetomarPedido(data)
				.then(({data}) =>{
					self.messageContact.show = true
					self.messageContact.type = 'success'
					self.messageContact.text = 'Se te ha enviado correctamente el pedido. Por favor verifíca tu correo.'
				})
				.catch(httpsError => {
					self.messageContact.show = true
					self.messageContact.type = 'error'
					self.messageContact.text = 'Hubo un error al enviar el correo, por favor intenta nuevamente.'
				})	
			},
        reservaPedido(type, procedencia){
            if(this.allData.baseValue && this.allData.finalValue){
                let data = {
                    type: type,
                    from: 5,
                    finalDataSave: {
                        first: this.allData.first,
                        second: this.allData.second,
                        third: this.allData.third,
                        basicoValue: this.allData.baseValue,
                        completoValue: this.allData.finalValue,
                        finalValue: this.allData.finalValue,
                        pedidoID: this.pedidoID,
                        servicio: "Completo"
                    }
                }
                let tipo = 'MudanzaFinal_' + procedencia + '_'
                if (this.allData.ajuste_mudanza) {
                    data.finalDataSave.ajuste_mudanza = this.allData.ajuste_mudanza
                }
                if(type == 1){data.finalDataSave.servicio = "Básico"}
                type == 1 ? tipo += 'básico' : tipo += 'completo'
                
                this.eventTracker(tipo)
                EventBus.$emit('reservaPedido', data)
            }
        },
        eventTracker(tipo) {
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        validate(){
            const finalDataSave = {
                first: this.allData.first,
                second: this.allData.second,
                third: this.allData.third,
                basicoValue: this.allData.baseValue,
                completoValue: this.allData.finalValue,
                finalValue: this.allData.finalValue,
                pedidoID: this.pedidoID,
                servicio: "Completo"
            }
			this.alreadyCalculated = true
            EventBus.$emit('finalValue', finalDataSave)
        },
        sortElement(){
            const here = this
            this.sortedElements = []
            this.allData.second.map(function(item) {
                let index = here.sortedElements.findIndex(x => x.cat == item.cat)
                if(index == -1){
                    here.sortedElements.push({ cat: item.cat, elements: [] })
                    const newIndex = here.sortedElements.length - 1
                    here.sortedElements[newIndex].elements.push(item)
                }
                else{
                    here.sortedElements[index].elements.push(item)
                }
            });
        },
        tiempoCarga(elementos){
            let volumen = 0
            elementos.forEach(function(item){
                volumen += item.metros * item.qty
            })
            return Math.round( (volumen * this.mantenedores.vol_tiempo) * 100 ) / 100
        },
        async setAjusteMudanza(type) {
            const db = firebase.firestore()
            const here = this
            await db.collection('mantenedores').doc('mantenedores').get().then(function(doc) {
                const mantenedores = doc.data()
				if (mantenedores.ajuste_mudanza > 0) {
					if (type === 1) {
						const valorAjusteBasico = here.allData.baseValue.amount * (1 - mantenedores.ajuste_mudanza)
						const ajuste = {
							ajuste_porcentaje: mantenedores.ajuste_mudanza,
							ajuste_valorBasico: Math.ceil(valorAjusteBasico / 1000) * 1000 - 10,
							ajuste_valorCompleto: 0
						}
						here.allData.ajuste_mudanza = ajuste
					
					} else if (type === 2){
						const valorAjusteBasico = here.allData.baseValue.amount * (1 - mantenedores.ajuste_mudanza)
						const valorAjusteCompleto = here.allData.finalValue.amount * (1 - mantenedores.ajuste_mudanza)
						const ajuste = {
							ajuste_porcentaje: mantenedores.ajuste_mudanza,
							ajuste_valorBasico: Math.ceil(valorAjusteBasico / 1000) * 1000 - 10,
							ajuste_valorCompleto: Math.ceil(valorAjusteCompleto / 1000) * 1000 - 10
						}
						here.allData.ajuste_mudanza = ajuste
					}
				}
                // here.loadingFinalValue = false
            }).catch(function() {
                // here.loadingFinalValue = false
                console.log('esto falla (Ajuste Mudanza)')
            })
        },
        getRoute(){
            this.$gmapApiPromiseLazy().then(() => {
                this.directionsService = new google.maps.DirectionsService()
                this.directionsDisplay = new google.maps.DirectionsRenderer()
                var vm = this
                console.og
                vm.directionsService.route({
                    origin: this.firstData.direccion_origen.direccion,
                    destination: this.firstData.direccion_destino.direccion,
                    travelMode: 'DRIVING'
                }, function (response, status) {
                    vm.theLatLngs = []
                    // la siguiente linea está comentada solo por mientras
                    vm.$refs.mapDirections.fitBounds(response.routes[0].bounds)
                    response.routes[0].overview_path.map(function(point){ 
                        vm.theLatLngs.push({lat: point.lat(), lng: point.lng()})
                    })
                    if (status === 'OK') {
                        vm.directionsDisplay.setDirections(response)
                    }
                })
            })

        },
        countItems(){
            const here = this
            this.elementsQty = 0
            this.secondData.map(function(element){ 
                here.elementsQty = here.elementsQty + element.qty
            })
        },
        textTiempo(){
            let volumen = 0
            this.secondData.forEach(function(item){
                volumen += item.metros * item.qty
            })
            const tiempo_volumen = Math.round( (volumen * this.mantenedores.vol_tiempo) * 100 ) / 100
            const tiempo_distancia = Math.round(this.firstData.distancia.duration.value/60)
            const tiempo_final = Math.ceil( (tiempo_volumen + tiempo_distancia + this.mantenedores.tiempo_margen)/60 )
            this.textTiempoVal = tiempo_final.toString() + ' horas tiempo máximo de servicio'
        },
        get_mantenedores(){
            let db = firebase.firestore()
            let self = this
            db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
                    if (doc.exists) {
                            self.mantenedores = doc.data()
                            //self.initHoursPicker()
                            EventBus.$emit('emmitMantenedores', self.mantenedores);
                    } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                    }
            }).catch(function(error) {
                    console.log("Error getting document:", error);
            });
        },
        setOfertaValue(amountTotal, type = 1){
            if(this.allData.first && this.allData.first.oferta.activo && !this.allData.ajuste_mudanza){
                if( (type === 1 && !this.allData.first.oferta.completo) || (type === 2 && this.allData.first.oferta.completo) ){
                    return amountTotal - this.allData.first.oferta.monto
                }
            }
            return amountTotal
        },
		setAddress(data){
			console.log(data.direcciones.origen)
				// Seteamos la data de dirección como promesa para poder esperar que esto esté listo en retomarPedido abajo
		return new Promise((resolve, reject) => {
			const self = this
			const geocoder = new google.maps.Geocoder()
			const origen = new Promise((resolve, reject) => {
				geocoder.geocode({'address': data.direcciones.origen}, function(results, status) {
				if (status === 'OK') {
					self.allData.first.direccion_origen.marker = results[0].geometry.location
				} else {
					alert('Geocode was not successful for the following reason: ' + status);
				}
				resolve(true)
				})
			})
			const destino = new Promise((resolve, reject) => {
				geocoder.geocode({'address': data.direcciones.destino}, function(results, status) {
				if (status === 'OK') {
					self.allData.first.direccion_destino.marker = results[0].geometry.location
				} else {
					alert('Geocode was not successful for the following reason: ' + status);
				}
				resolve(true)
				})	
			})

			Promise.all([origen, destino]).then(values => { 
				resolve(true)
			});
			})  
		}
    },
    mounted() {
        this.get_mantenedores()
        EventBus.$on('enterMudanzaFourth', data => {
			this.allData = {}
            this.allData = data
            this.firstData.distancia = data.first.distancia
			if (data.dialogPersonalesValidate) {
				this.dataPersonalF.email = data.dataPersonal.email
				this.dataPersonalF.telefono = data.dataPersonal.telefono
				this.dialogPersonalesValidate = false
			}
            this.sortElement()
			this.loadingFinalValue = true
            this.initCalc()
            
        })
        EventBus.$on('mudanzaSecond', data => {
            this.secondData = data.datos
            // this.textTiempo()
        })
        EventBus.$on('mudanzaFirst', data => {
            if (!data.directions) {
                this.firstData = data.datos    
            } else {
                this.firstData.direccion_origen.direccion = data.direccion_origen.direccion
                this.firstData.direccion_destino.direccion = data.direccion_destino.direccion
            }
        })
		
        EventBus.$on('idPedido', data => {
            this.pedidoID = data.pedidoID
			this.finalCalc()
        })
		EventBus.$on('idPedidoRetomar', data => {
			this.pedidoID = data.pedidoID
		})
		EventBus.$on('retomarPedidoFourth', async data => {
			console.log(data.ajuste_mudanza)
			this.allData = data
			this.dataPersonalF.email = data.first.personales.email
			this.dataPersonalF.telefono = data.first.personales.telefono
			this.direcciones.origen = data.first.direccion_origen.direccion
			this.direcciones.destino = data.first.direccion_destino.direccion
			const dataDireccion = {
				direcciones: this.direcciones
			}
			this.secondData = data.second
			this.firstData = data.first
			this.countItems()
			await this.setAddress(dataDireccion)
			await this.getRoute()
			this.loadingFinalValue = false
			this.continuar = false
		})
    }
}
</script>